import { createApp } from 'vue'
import PracticeGamesUser from './components/practice_games_user_app'
import $ from 'jquery'

export function embedPracticeGame(options = {}) {
  if ($('.practice-games-markup-application').length > 0) {
    $('.practice-games-markup-application').each(function() {
      const gameSlug = $(this).data('slug')

      const xhr = {
        dataType: 'json',
        method: 'GET',
        url: '/practice_games',
        showPreloader: typeof(options.showPreloader) == 'undefined' ? true : options.showPreloader
      }

      SOPHIA.sendXHR(xhr).then(response => {
        const currentGame = response.items.find(obj => {
          return obj.slug === gameSlug
        })

        const xhr = {
          method: 'GET',
          url: '/practice_games/' + currentGame.id,
          showPreloader: typeof(options.showPreloader) == 'undefined' ? true : options.showPreloader
        }
        SOPHIA.sendXHR(xhr).then(response => {
          createApp(PracticeGamesUser, { game: response }).mount('.practice-games-markup-application');
        })
      })
    })
  }
}
